import TagItem from "./TagItem";

import "./TagItem.scss";

export * from "./TagItem.types";

export { TagItem };